/**
 * 动态列表相关操作方法
 */

import { hideCode } from '@/utils/index';
import moment from 'dayjs';
import { message } from 'ant-design-vue'
import { saveCopyLog } from "@/api/detail"

// 图片字段
const imageFields = ['pay_voucher_picture'];

/**
 * 获取表格列配置
 * @param field         表格显示字段信息
 * @param btnOptions    按钮权限集合
 * @param filterType    过滤器类型：0客户1订单2公海
 * @param filterId      过滤器Id
 * @returns {{}}
 */
export const getColumnConfig = (field, btnOptions, filterType, filterId) => {
    // 字段配置
    const fieldConfig = field.commonProperties ? JSON.parse(field.commonProperties).options || {} : {};
    // 字段选项（下拉框字段）
    const options = field.options ? JSON.parse(field.options) : fieldConfig.options || [];
    return {
        // 是否图片列
        isImage: imageFields.includes(field.fieldCode),
        // 是否加密字段
        currentRoleIsEncrypted: isCurrentRoleIsEncrypted(field, filterType, filterId),
        // 加密字段渲染问题
        encryptedRender: encryptedRender,
        // 加密字段是否显示复制按钮
        currentRoleIsShowCopyButton: field.currentRoleIsShowCopyButton || 0,
        // 是否可复制
        isClipboard: fieldConfig.clipboard || false,
        // 表格列宽度
        columnWidth: fieldConfig.columnWidth || null,
        // 是否为状态字段显示
        isStatusField: fieldConfig.isStatusField || false,
        // 下拉框是否显示颜色
        isSelectShowColor: fieldConfig.isSelectShowColor || false,
        // 状态样式class
        statusClass: text => {
            let textStr = '';
            for (let i = 0, len = options.length; i < len; i++) {
                if (options[i].value === Number(text)) {
                    textStr = options[i].color;
                    break;
                }
            }
            return textStr;
        },
        // 选项值（下拉框字段）
        options: options,
        // 渲染字段
        customRender: text => {
            if ([ 'select', 'radio' ].includes(field.fieldFormType)) {
                let textStr = '-';
                const options = field.options
                    ? JSON.parse(field.options)
                    : JSON.parse(field.commonProperties).options.options || [];
                for (let i = 0, len = options.length; i < len; i++) {
                    if (options[i].value === Number(text)) {
                        textStr = options[i].label;
                        break;
                    }
                }
                return textStr;
            }
            else if (field.fieldFormType === 'checkbox') {
                let textStr = '';
                const options = JSON.parse(field.options);
                const values = text ? text.split(',').map(Number) : [];
                for (let i = 0, len = options.length; i < len; i++) {
                    if (values.includes(options[i].value)) {
                        textStr += `${options[i].label},`;
                    }
                }
                return textStr.substring(0, text ? textStr.length - 1 : 0) || '-';
            }
            else if (field.fieldFormType === 'date') {
                return text
                    ? moment(text).format(field.commonProperties ? fieldConfig.format : 'YYYY-MM-DD HH:mm:ss')
                    : '-' // eslint-disable-line
            }
            else if (field.fieldFormType === 'time') {
                return text;
                // return text ? moment(text).format(field.commonProperties ? fieldConfig.format : 'HH:mm:ss') : '-' // eslint-disable-line
            }
            else if (field.fieldFormType === 'number') {
                return text || text === 0 ? text : '-';
            }
            else if (field.fieldFormType === 'region') {
                if (text) {
                    try {
                        let regionText = '',
                            regionOptions = JSON.parse(text);
                        regionOptions.forEach(item => {
                            regionText += `${item.name}/`;
                        });
                        return regionText.substring(0, regionText.length - 1);
                    }
                    catch (e) {
                        return '-';
                    }
                }
                else {
                    return '-';
                }
            }
            return text || '-';
        },
    };
};

/**
 * 判断是否加密字段
 * @param field
 * @param filterType
 * @param filterId
 * @returns {*|number} 1是0否
 */
const isCurrentRoleIsEncrypted = (field, filterType, filterId) => {
    !field && console.log(filterType, filterId);
    return field.currentRoleIsEncrypted || 0;
};

/**
 * 字段加密
 * @param text
 * @returns {string|*}
 */
/* eslint-disable */
export const encryptedRender = (text) => {
    // console.log(136,text);
    if(text.length){
        text = text.toString().trim()
        if(text.length <= 1){
            return '*';
        }else if(text.length === 2){
            return hideCode(text, 1, 0);
        }else if(text.length >= 3 && text.length <= 6){
            return hideCode(text, 1, 1);
        }else if(text.length === 7){
            return hideCode(text, 2, 2);
        }else if(text.length === 8){
            return hideCode(text, 2, 2);
        }else if(text.length === 9){
            return hideCode(text, 2, 3);
        }else if(text.length === 10){
            return hideCode(text, 3, 3);
        }else if(text.length >= 11 && text.length <= 20){
            return hideCode(text, 3, 4);
        }else if(text.length >= 20 && text.length <= 40){
            return hideCode(text, 8, 8);
        }else if(text.length > 40){
            return hideCode(text, 16, 16);
        }
    }
    return text
}
/* eslint-disable */

/**
 * 字段复制
 * @param text
 * @returns {string|*}
 */
export const handleCopy = (params) => {
    console.log('params',params);
    let copyValue = typeof params === 'object' ? params.copyFieldValue : params
    const input = document.createElement('input')
    document.body.appendChild(input)
    input.setAttribute('value', copyValue)
    input.select()
    input.setSelectionRange(0, input.value.length)
    if (document.execCommand('copy')) {
      document.execCommand('copy')
      message.success('复制成功，请前往粘贴！')
      if (typeof params === 'object') {
         const canShu = JSON.parse(JSON.stringify(params))
        canShu.copyFieldValue = copyValue
        console.log('复制走接口～');
        saveCopyLog(params).then((res) => {})
      }else{
        console.log('常规复制，不走接口');
      }
    } else {
      message.error('复制失败')
    }
    document.body.removeChild(input)
}
/**
 * 预置加密字段复制
 * @param text
 * @returns {string|*}
 */
export const handlePresetEncryptCopy = (params) => {
  console.log('11这里都有些什么', params)
//   return
  try {
    saveCopyLog(params).then((res) => {
      let copyValue = res.result
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', copyValue)
      input.select()
      input.setSelectionRange(0, input.value.length)
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        message.success('复制成功，请前往粘贴！')
        if (typeof params === 'object') {
        }
      } else {
        message.error('复制失败')
      }
      document.body.removeChild(input)
    })
  } catch (e) {
    message.error('复制失败')
  }
}

  
